import React from "react";
import { Link } from "react-router-dom";
import { LogOut, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { LangToggle, iconBtnClass } from "@/components/Brand";

/** Sliding drawer navigation for small screens. */
export const MobileNavDrawer = ({ links, pathname, email, onClose, onSignOut }) => {
  const { t } = useI18n();

  return (
    <div className="md:hidden fixed inset-0 z-[60] bg-black/80" data-testid="mobile-menu-backdrop"
      onClick={onClose}>
      <div
        data-testid="mobile-menu"
        onClick={(e) => e.stopPropagation()}
        className="absolute right-0 top-0 h-full w-[82%] max-w-xs bg-[#0B0B0B] border-l border-[#2A2A2A] flex flex-col safe-bottom"
      >
        <div className="flex items-center justify-between px-5 h-16 border-b border-[#1E1E1E]">
          <span className="eyebrow text-[#D4AF37]">{t("menu")}</span>
          <button data-testid="mobile-menu-close" onClick={onClose}
            className={`${iconBtnClass} text-[#A8A8A8] hover:text-[#D4AF37]`} aria-label={t("close")}>
            <X size={20} />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto py-2">
          {links.map((l) => (
            <Link
              key={l.to}
              data-testid={`mobile-nav-${l.to.slice(1)}`}
              to={l.to}
              className={`flex items-center px-5 min-h-[56px] text-xs tracking-[0.18em] uppercase border-b border-[#141414] transition-colors ${
                pathname === l.to ? "text-[#D4AF37] bg-[#D4AF37]/[0.04]" : "text-[#F3F3F1]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="px-5 py-5 border-t border-[#1E1E1E] space-y-5">
          <p data-testid="mobile-menu-email" className="text-xs text-[#707070] break-all">{email}</p>
          <LangToggle />
          <button data-testid="mobile-logout-btn" onClick={onSignOut}
            className="flex items-center gap-3 min-h-[44px] text-[11px] tracking-[0.18em] uppercase text-[#A8A8A8] hover:text-[#D4AF37] transition-colors">
            <LogOut size={16} /> {t("logout")}
          </button>
        </div>
      </div>
    </div>
  );
};
